import React from "react";

const CustomPopover = ({
  id,
  open,
  anchorEl,
  onClose,
  anchorOrigin = { vertical: "bottom", horizontal: "left" },
  children,
  closeOnClickOutside = true,
  stickyPosition,
  childHeight,
  childWidth,
}: {
  id?: string | undefined;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  anchorOrigin?: {
    vertical: "bottom" | "top";
    horizontal: "left" | "right";
  };
  children: React.ReactNode;
  closeOnClickOutside?: boolean;
  stickyPosition?: {
    top?: number;
    left?: number;
  };
  childHeight?: number;
  childWidth?: number;
}) => {
  const getTopPositioning = () => {
    if (stickyPosition) {
      return {
        top: stickyPosition.top,
        left: stickyPosition.left,
      };
    }
    const anchorRect = anchorEl?.getBoundingClientRect();
    const maxTopPosition = window.innerHeight - (childHeight || 300);
    if (anchorRect) {
      if (anchorRect.bottom > maxTopPosition) {
        return {
          bottom: window.innerHeight - anchorRect.top,
        };
      } else {
        return {
          top: anchorRect.bottom,
        };
      }
    }
    return {};
  };

  const getLeftPositioning = () => {
    if (stickyPosition?.left !== undefined) {
      return stickyPosition.left;
    }

    const anchorRect = anchorEl?.getBoundingClientRect();
    if (!anchorRect) return 0;

    const popupWidth = childWidth || 300; // Default width if not provided
    const screenWidth = window.innerWidth;
    const padding = 16; // Minimum padding from screen edge

    if (anchorOrigin.horizontal === "left") {
      // Check if popup would overflow the right edge
      if (anchorRect.left + popupWidth > screenWidth - padding) {
        // Position popup to the left of the anchor element
        return Math.max(padding, anchorRect.right - popupWidth);
      }
      return anchorRect.left;
    } else {
      // anchorOrigin.horizontal === "right"
      // Check if popup would overflow the left edge
      if (anchorRect.right - popupWidth < padding) {
        // Position popup to the right of the anchor element
        return Math.min(screenWidth - popupWidth - padding, anchorRect.left);
      }
      return anchorRect.right - popupWidth;
    }
  };

  return open ? (
    closeOnClickOutside ? (
      <div
        className="absolute top-0 left-0 w-full h-full z-[900]"
        onClick={onClose}
      >
        <div
          id={id}
          className="absolute bg-white shadow-lg rounded-md border border-gray-200"
          style={{
            ...getTopPositioning(),
            left: getLeftPositioning(),
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {children}
        </div>
      </div>
    ) : (
      <div
        id={id}
        className="absolute bg-white shadow-lg rounded-md border border-gray-200 z-[900]"
        style={{
          ...getTopPositioning(),
          left: getLeftPositioning(),
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {children}
      </div>
    )
  ) : (
    <></>
  );
};

export default CustomPopover;
